import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navigation({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const initials = user?.name
    ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* ── Top Navigation Bar ── */}
      <nav className="nav-top">
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <div style={{
            width: 34, height: 34, borderRadius: 10,
            background: 'linear-gradient(135deg, #a3e635 0%, #4ade80 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 17, flexShrink: 0,
          }}>
            🥗
          </div>
          <span style={{
            fontSize: 16, fontWeight: 700, color: '#f1f5f9',
            letterSpacing: '-0.02em', fontFamily: 'Inter, sans-serif',
          }}>
            NutriTrack
          </span>
        </Link>

        {/* Desktop Nav Links */}
        <div className="nav-links">
          <NavLink to="/"        label="Dashboard" active={isActive('/')} />
          <NavLink to="/profile" label="Profile"   active={isActive('/profile')} />
        </div>

        {/* Right: User + Logout */}
        <div className="nav-right" style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          {user && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{
                width: 34, height: 34, borderRadius: '50%',
                background: 'linear-gradient(135deg, #a3e635 0%, #4ade80 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 13, fontWeight: 700, color: '#0a0d12',
                fontFamily: 'Inter, sans-serif', flexShrink: 0,
              }}>
                {initials}
              </div>
              <span className="nav-user-name" style={{
                fontSize: 13, fontWeight: 500,
                color: 'rgba(241,245,249,0.6)',
                fontFamily: 'Inter, sans-serif',
              }}>
                {user.name?.split(' ')[0]}
              </span>
            </div>
          )}
          <button
            className="nav-logout-btn"
            onClick={handleLogout}
            style={{
              background: 'rgba(248,113,113,0.1)',
              border: '1px solid rgba(248,113,113,0.2)',
              borderRadius: 8,
              color: '#f87171',
              fontSize: 13, fontWeight: 600,
              padding: '7px 14px',
              cursor: 'pointer',
              fontFamily: 'Inter, sans-serif',
              transition: 'all 0.2s',
              minHeight: 36,
            }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(248,113,113,0.18)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(248,113,113,0.1)'; }}
          >
            Sign out
          </button>
        </div>
      </nav>

      {/* ── Mobile Bottom Tab Bar ── */}
      <div className="bottom-tab-bar">
        <Link
          to="/"
          className={`tab-item ${isActive('/') ? 'active' : ''}`}
        >
          <span className="tab-icon">🏠</span>
          <span className="tab-label">Dashboard</span>
        </Link>

        <Link
          to="/profile"
          className={`tab-item ${isActive('/profile') ? 'active' : ''}`}
        >
          <span className="tab-icon">👤</span>
          <span className="tab-label">Profile</span>
        </Link>

        <button
          onClick={handleLogout}
          className="tab-item tab-logout"
        >
          <span className="tab-icon">🚪</span>
          <span className="tab-label">Sign out</span>
        </button>
      </div>
    </>
  );
}

function NavLink({ to, label, active }) {
  return (
    <Link
      to={to}
      style={{
        padding: '7px 14px',
        borderRadius: 8,
        fontSize: 14,
        fontWeight: 500,
        fontFamily: 'Inter, sans-serif',
        textDecoration: 'none',
        color: active ? '#a3e635' : 'rgba(241,245,249,0.55)',
        background: active ? 'rgba(163,230,53,0.08)' : 'transparent',
        transition: 'all 0.2s',
        display: 'inline-block',
      }}
    >
      {label}
    </Link>
  );
}
